import type { ReactNode } from "react"
import { Separator } from "@/components/ui/separator"

interface CategoryGroupProps {
  category: string
  children: ReactNode
}

export function CategoryGroup({ category, children }: CategoryGroupProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center">
        <h2 className="flex-grow text-base font-semibold text-foreground mr-2">{category}</h2>
        <Separator />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">{children}</div>
    </div>
  )
}
